/* eslint-disable */
import { TemporaryAccessStatus } from '../dto/temporary-access-status';

export interface TemporaryAccessCustomerListDto {
  id: number;
  userFirstName?: string | null;
  userLastName?: string | null;
  roles: string[];
  status: TemporaryAccessStatus;
  requestedAt: Date;
  expiresAt?: Date | null;
}

export const fixTemporaryAccessCustomerListDtoFromJson = (dto?: TemporaryAccessCustomerListDto | null): void => {
  if (!dto) {
    return;
  }
  dto.requestedAt = dto.requestedAt && new Date(dto.requestedAt);
  dto.expiresAt = dto.expiresAt && new Date(dto.expiresAt);
};

export const fixTemporaryAccessCustomerListDtoToJson = (dto?: TemporaryAccessCustomerListDto | null): void => {
  if (!dto) {
    return;
  }
};
